import { css, styled } from "@/styles/stitches.config";
import { useSignal } from "@preact-signals/safe-react";
import { StitchesBox } from "../../components/stitches/box";
import { actionsImages } from "./actions-images";
import { companyDomainService } from "@/api/acendex/company";
import { useTranslation } from "react-i18next";

const StyledBox = styled(StitchesBox, {
  marginTop: "0 !important",
  display: "flex !important",
  justifyContent: "center !important",
  borderRadius: "100px !important",
  cursor: "pointer",
  position: "relative",
  alignItems: "center",
  transition: "all 0.3s ease",
  overflow: "hidden",

  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 8px rgba(151, 80, 221, 0.25)",
  },

  "&:active": {
    transform: "translateY(0)",
  },

  "&::before": {
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(255, 255, 255, 0.1)",
    transform: "scale(0)",
    opacity: 0,
    transition: "transform 0.4s, opacity 0.4s",
    borderRadius: "inherit",
  },

  "&:hover::before": {
    opacity: 1,
    transform: "scale(1)",
  },

  variants: {
    active: {
      true: {
        background: "linear-gradient(94deg, #bb66d9 3.61%, #9656d6 77.52%)",
        fontWeight: "bold",

        "&:hover": {
          transform: "scale(1.05) translateY(-2px)",
        },

        "&::after": {
          content: "''",
          position: "absolute",
          bottom: "6px",
          left: "50%",
          width: "20px",
          height: "2px",
          background: "white",
          transform: "translateX(-50%)",
          borderRadius: "2px",
          animation: "fadeIn 0.3s ease forwards",
        },
      },
    },
  },

  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "translateX(-50%) scaleX(0)" },
    "100%": { opacity: 1, transform: "translateX(-50%) scaleX(1)" },
  },
});

export function ActionsList() {
  const activeIndex = useSignal(0);
  const requestCompanyDomain = companyDomainService.useFetch({
    isInit: true,
  });
  const { t } = useTranslation();

  return (
    <div
      data-v-6f7b3c35=""
      data-v-9c24da2b=""
      className="md:my-20 present relative mx-auto container md:rounded-[30px] text-white sm:pt-10 pt-4 md:pt-0 overflow-hidden"
    >
      <div
        data-v-6f7b3c35=""
        className="tabs relative box-border flex h-16 md:w-[1040px] gap-x-2.5 rounded-[100px] mt-8 p-2 mx-2 md:mx-auto"
      >
        {["出入金", "交易", "理财", "资产管理"].map((item, index) => (
          <StyledBox
            key={index}
            data-v-6f7b3c35=""
            className={`p-2 item md:p-[15px] text-xs md:text-base md:flex-1 flex-none`}
            active={activeIndex.value === index}
            onClick={() => (activeIndex.value = index)}
          >
            {t(`acendex.${item}`)}
          </StyledBox>
        ))}
        <div
          data-v-6f7b3c35=""
          className="active absolute bottom-2 top-2 rounded-[100px]"
        ></div>
      </div>
      {activeIndex.value === 0 && (
        <div
          data-v-6f7b3c35=""
          className="tabs-panel flex-col my-2 md:my-0 md:flex-row sm:gap-x-[90px]"
        >
          <img
            data-v-6f7b3c35=""
            src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/home_crypto.webp"
            width="280"
            height="453.5"
            alt="home_crypto"
            className={css({
              width: "calc(100% - 20px)",
              "@md": {
                width: "280px",
              },
            })()}
          />
          <div data-v-6f7b3c35="" className="sm:w-[574px] mx-4 md:mx-0">
            <p data-v-6f7b3c35="" className="mb-5 text-2xl font-bold">
              {t("acendex.同时支持快捷买币和链上充值")}
            </p>
            <p data-v-6f7b3c35="" className="mb-5 text-xl font-medium">
              {t("acendex.第三方买币")}
            </p>
            <p data-v-6f7b3c35="" className="mb-5 text-base font-lighter">
              {t(
                "acendex.使用苹果、谷歌支付或信用卡便捷买币，不限量兑换数百种加密货币"
              )}
            </p>
            <div
              className="grid grid-cols-2 gap-2 md:flex gap-x-2 sm:my-5"
              data-v-6f7b3c35=""
            >
              <div className="pmethods aspect-video" data-v-6f7b3c35="">
                <img
                  src={actionsImages.visa.src}
                  alt="visa"
                  data-v-6f7b3c35=""
                />
              </div>
              <div className="pmethods aspect-video" data-v-6f7b3c35="">
                <img
                  src={actionsImages.mastercard.src}
                  alt="masterCard"
                  data-v-6f7b3c35=""
                />
              </div>
              <img
                src={actionsImages.applePay.src}
                className="sm:w-70 sm:h-10 w-full aspect-video"
                alt="ApplePay"
                data-v-6f7b3c35=""
              />
              <img
                src={actionsImages.GooglePay.src}
                className="sm:w-70 sm:h-10 w-full aspect-video"
                alt="GooglePay"
                data-v-6f7b3c35=""
              />
            </div>
            <ul
              className="buy grid grid-cols-2 gap-2 mt-2 md:mt-0 md:flex gap-x-5"
              data-v-6f7b3c35=""
            >
              <li data-v-6f7b3c35="">
                <img
                  src={actionsImages.banxa.src}
                  alt="banxa"
                  data-v-6f7b3c35=""
                />
                <span data-v-6f7b3c35="">BANXA</span>
              </li>
              <li data-v-6f7b3c35="">
                <img
                  src={actionsImages.mercuryo.src}
                  alt="mercuryo"
                  data-v-6f7b3c35=""
                />
                <span data-v-6f7b3c35="">MERCURYO</span>
              </li>
              <li data-v-6f7b3c35="">
                <img
                  src={actionsImages.moonpay.src}
                  alt="moonpay"
                  data-v-6f7b3c35=""
                />
                <span data-v-6f7b3c35="">MOONPAY</span>
              </li>
              <li data-v-6f7b3c35="">
                <img
                  src={actionsImages.simplex.src}
                  alt="simplex"
                  data-v-6f7b3c35=""
                />
                <span data-v-6f7b3c35="">SIMPLEX</span>
              </li>
            </ul>
            <div
              className="my-6 border border-solid border-[#5D417C]"
              data-v-6f7b3c35=""
            ></div>
            <p data-v-6f7b3c35="" className="mb-2.5 text-xl font-bold">
              {t("acendex.链上充值")}
            </p>
            <p data-v-6f7b3c35="" className="mb-10 text-base font-lighter">
              {t(
                "acendex.从外部钱包或其他平台将加密货币存入您的{{companyName}}账户",
                { companyName: requestCompanyDomain.data.value?.companyName }
              )}
            </p>
            <div
              data-v-6f7b3c35=""
              className="flex sm:gap-x-[50px] gap-2 mb-2 md:mb-0"
            >
              <a
                data-v-6f7b3c35=""
                href="/c2cckcenter"
                className="present-btn rounded-md px-2"
              >
                {t("acendex.第三方买币")}
              </a>
              <a
                data-v-6f7b3c35=""
                href="/rechargelist"
                className="present-btn rounded-md px-2"
              >
                {t("acendex.链上充值")}
              </a>
            </div>
          </div>
        </div>
      )}
      {activeIndex.value === 1 && (
        <div
          data-v-6f7b3c35=""
          className="tabs-panel flex-col md:flex-row sm:gap-x-[45px]"
        >
          <img
            data-v-6f7b3c35=""
            src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/home_trade.webp"
            className="w-full md:w-[498px] sm:-translate-y-8"
            alt="home_trade"
          />
          <div
            data-v-6f7b3c35=""
            className="w-[70vw] my-3 md:my-0 md:w-[480px] sm:-translate-y-9"
          >
            <p
              data-v-6f7b3c35=""
              className="text-2xl font-bold leading-9 sm:mb-5"
            >
              {t("acendex.产品线覆盖现货、杠杆、杠杆代币、合约、跟单")}
            </p>
            <p data-v-6f7b3c35="" className="text-base font-lighter sm:mb-10">
              {t(
                "acendex.产品线多样，满足你所有的交易需求，强劲的交易撮合引擎、超低延迟、庞大的吞吐量、极峰不抖动、高峰不宕机"
              )}
            </p>
            <a
              data-v-6f7b3c35=""
              href="/trade/btc"
              className="present-btn inline-block sm:min-w-[180px] rounded-md px-2 mt-4 md:mt-0"
            >
              {t("acendex.立即交易")}
            </a>
          </div>
        </div>
      )}
      {activeIndex.value === 2 && (
        <div
          data-v-6f7b3c35=""
          className="tabs-panel flex-col md:flex-row sm:gap-x-[75px]"
        >
          <img
            data-v-6f7b3c35=""
            src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/home_earn.webp"
            className="w-[90%] md:w-[504px] sm:-translate-y-8"
            alt="home_earn"
          />
          <div
            data-v-6f7b3c35=""
            className="w-[70vw] my-3 md:my-0 md:w-[480px] sm:-translate-y-8"
          >
            <p
              data-v-6f7b3c35=""
              className="text-2xl font-bold leading-9 sm:mb-5"
            >
              {t("acendex.超百种资产可选，纵享超高收益率")}
            </p>
            <p
              data-v-6f7b3c35=""
              className="text-base font-lighter sm:mb-10 sm:w-[430px]"
            >
              {t(
                "acendex.存币生息的同时还可以将理财资产作为杠杆和合约交易的保证金，提升交易财力"
              )}
            </p>
            <a
              data-v-6f7b3c35=""
              href="/trade/btc"
              className="present-btn inline-block sm:min-w-[180px] rounded-md px-2 mt-4 md:mt-0"
            >
              {t("acendex.前往理财")}
            </a>
          </div>
        </div>
      )}
      {activeIndex.value === 3 && (
        <div
          data-v-6f7b3c35=""
          className="tabs-panel flex-col md:flex-row sm:gap-x-[97px]"
        >
          <img
            data-v-6f7b3c35=""
            src="//static1.asdxstatic.com/web-res/pt/tag-1741600120/images/home/home_asset_manage.webp"
            className="w-[90%] md:w-[427px]"
            alt="home_asset_manage"
          />
          <div
            data-v-6f7b3c35=""
            className="w-[70vw] my-3 md:my-0 md:w-[440px]"
          >
            <p
              data-v-6f7b3c35=""
              className="text-2xl font-bold leading-9 sm:mb-5"
            >
              {t("acendex.一站式资产管理")}
            </p>
            <ul data-v-6f7b3c35="" className="assets-ul sm:mb-[30px]">
              <li data-v-6f7b3c35="">
                <div data-v-6f7b3c35="" className="items">
                  <div data-v-6f7b3c35="" className="circle">
                    <svg
                      data-v-6f7b3c35=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="18"
                      viewBox="0 0 11 18"
                      fill="none"
                    >
                      <path
                        data-v-6f7b3c35=""
                        d="M1.22733 3.3545C2.3546 3.19087 3.37278 2.8545 4.28187 2.34541C5.20915 1.83632 5.94551 1.23632 6.49096 0.54541H10.6637L6.9546 17.8636H1.06369L3.76369 5.18177H0.818237L1.22733 3.3545Z"
                        fill="white"
                      ></path>
                    </svg>
                  </div>
                  <span data-v-6f7b3c35="">{t("acendex.专业透明")}</span>
                </div>
                <p data-v-6f7b3c35="">
                  {t("acendex.提供更专业、丰富的资产管理和图表分析")}
                </p>
              </li>
              <li data-v-6f7b3c35="">
                <div data-v-6f7b3c35="" className="items">
                  <div data-v-6f7b3c35="" className="circle">
                    <svg
                      data-v-6f7b3c35=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="18"
                      viewBox="0 0 17 18"
                      fill="none"
                    >
                      <path
                        data-v-6f7b3c35=""
                        d="M0.690942 14.9182C1.94549 14.5182 3.16367 14.0182 4.34549 13.4182C5.52731 12.8 6.58185 12.0636 7.50913 11.2091C8.4364 10.3364 9.17276 9.32727 9.71822 8.18182C10.2819 7.03636 10.5637 5.71818 10.5637 4.22727C10.5637 3.5 10.4909 2.93636 10.3455 2.53636C10.2 2.13636 9.94549 1.93636 9.58185 1.93636C9.25458 1.93636 8.94549 2.09091 8.65458 2.4C8.38185 2.70909 8.12731 3.1 7.89094 3.57273C7.67276 4.04545 7.46367 4.57273 7.26367 5.15455C7.08185 5.73636 6.92731 6.3 6.80003 6.84546H1.86367L2.76367 2.75455C3.78185 1.88182 4.85458 1.20909 5.98185 0.736364C7.10912 0.245455 8.38185 0 9.80003 0C10.6728 0 11.4909 0.1 12.2546 0.300001C13.0364 0.500001 13.7091 0.818182 14.2728 1.25455C14.8546 1.67273 15.3091 2.20909 15.6364 2.86364C15.9819 3.5 16.1546 4.26364 16.1546 5.15455C16.1546 5.82727 16.0364 6.49091 15.8 7.14546C15.5819 7.8 15.1819 8.48182 14.6 9.19091C14.0364 9.88182 13.2637 10.6091 12.2819 11.3727C11.3182 12.1182 10.0909 12.9273 8.60003 13.8H14.6819L14.1364 17.5909H0.0909424L0.690942 14.9182Z"
                        fill="white"
                      ></path>
                    </svg>
                  </div>
                  <span data-v-6f7b3c35="">{t("acendex.安全")}</span>
                </div>
                <p data-v-6f7b3c35="">
                  {t(
                    "acendex.实时审计与风险管理，保障资金安全专业的第三方安全机构审计，专业的第三方安全机构审计"
                  )}
                </p>
              </li>
              <li data-v-6f7b3c35="">
                <div data-v-6f7b3c35="" className="items">
                  <div data-v-6f7b3c35="" className="circle">
                    <svg
                      data-v-6f7b3c35=""
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                    >
                      <path
                        data-v-6f7b3c35=""
                        d="M6.3364 17.8091C5.04549 17.8091 3.90912 17.6455 2.92731 17.3182C1.94549 16.9727 1.00003 16.3727 0.0909424 15.5182L0.96367 11.4273H5.57276C5.57276 11.4091 5.55458 11.4727 5.51822 11.6182C5.50003 11.7636 5.47276 11.9545 5.4364 12.1909C5.41822 12.4273 5.39094 12.6909 5.35458 12.9818C5.3364 13.2727 5.32731 13.5545 5.32731 13.8273C5.32731 14.5727 5.41822 15.1091 5.60003 15.4364C5.80003 15.7455 6.07276 15.9 6.41822 15.9C6.80003 15.9 7.15458 15.7727 7.48185 15.5182C7.82731 15.2636 8.11822 14.9455 8.35458 14.5636C8.59094 14.1818 8.77276 13.7636 8.90003 13.3091C9.04549 12.8364 9.11822 12.3818 9.11822 11.9455C9.11822 11.1091 8.90003 10.4909 8.46367 10.0909C8.04549 9.67273 7.52731 9.46364 6.90912 9.46364C6.96367 9.11818 7.02731 8.80909 7.10003 8.53636C7.15458 8.3 7.20003 8.09091 7.2364 7.90909C7.29094 7.70909 7.31822 7.6 7.31822 7.58182C7.91822 7.58182 8.41821 7.49091 8.81822 7.30909C9.2364 7.10909 9.57276 6.84546 9.82731 6.51818C10.1 6.17273 10.2909 5.77273 10.4 5.31818C10.5091 4.84546 10.5637 4.34546 10.5637 3.81818C10.5637 3.6 10.5455 3.38182 10.5091 3.16364C10.4909 2.92727 10.4455 2.71818 10.3728 2.53636C10.3 2.33636 10.1909 2.18182 10.0455 2.07273C9.91822 1.94545 9.7364 1.88182 9.50003 1.88182C9.00913 1.88182 8.52731 2.17273 8.05458 2.75455C7.60003 3.33636 7.19094 4.32727 6.82731 5.72727H2.1364L2.95458 1.88182C3.50003 1.53636 4.12731 1.22727 4.8364 0.954546C5.4364 0.718182 6.15458 0.500001 6.99094 0.300001C7.84549 0.1 8.81822 0 9.90912 0C10.6182 0 11.3273 0.0636366 12.0364 0.19091C12.7455 0.3 13.3819 0.509091 13.9455 0.818183C14.5273 1.12727 14.9909 1.54545 15.3364 2.07273C15.7 2.6 15.8819 3.27273 15.8819 4.09091C15.8819 4.70909 15.7728 5.25455 15.5546 5.72727C15.3546 6.18182 15.0546 6.59091 14.6546 6.95455C14.2546 7.31818 13.7728 7.64546 13.2091 7.93637C12.6637 8.22727 12.0364 8.5 11.3273 8.75455C11.8728 8.80909 12.3819 8.91818 12.8546 9.08182C13.3273 9.24546 13.7364 9.47273 14.0819 9.76364C14.4455 10.0545 14.7273 10.4091 14.9273 10.8273C15.1455 11.2455 15.2546 11.7455 15.2546 12.3273C15.2546 13.1091 15.0455 13.8364 14.6273 14.5091C14.2091 15.1818 13.6091 15.7636 12.8273 16.2545C12.0637 16.7455 11.1273 17.1273 10.0182 17.4C8.92731 17.6727 7.70003 17.8091 6.3364 17.8091Z"
                        fill="white"
                      ></path>
                    </svg>
                  </div>
                  <span data-v-6f7b3c35="">{t("acendex.可信赖的平台")}</span>
                </div>
                <p data-v-6f7b3c35="">
                  {t("acendex.严格遵循行业规则，不参与市场运作")}
                </p>
              </li>
            </ul>
            <a
              data-v-6f7b3c35=""
              href="/propertycenter"
              className="present-btn inline-block sm:min-w-[180px] rounded-md px-2 mt-4 md:mt-0"
            >
              {t("acendex.查看钱包")}
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
